export enum ALIGNMENT_TYPES {
  SPACE_BETWEEN = 'space-between',
}
